"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _r10SourceLibrary = require("r10-source-library");
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _useDynamicPageContent = _interopRequireDefault(require("../../../hooks/dynamic/useDynamicPageContent"));
var _useUpsell2 = _interopRequireDefault(require("../../../hooks/upsell/useUpsell"));
var _services = require("../../../services");
var _widgetSelectors = require("../../../store/widget/widgetSelectors");
var _constants = require("../../../utils/constants");
var _CharacteristicsGroup = _interopRequireDefault(require("./PageComponents/CharacteristicsGroup"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var UpsellConnectivityPlanBody = function UpsellConnectivityPlanBody() {
  var _useUpsell = (0, _useUpsell2.default)(),
    connectivityPlan = _useUpsell.connectivityPlan,
    setConnectivityPlanIsSelected = _useUpsell.setConnectivityPlanIsSelected;
  var offering = connectivityPlan.offering,
    selected = connectivityPlan.selected;
  var characteristics = offering.productSpecification.productSpecCharacteristic;
  var specsGroups = (0, _reactRedux.useSelector)(_widgetSelectors.selectProductCatalog).connectivityPlan.specsGroups;
  var _useDynamicPageConten = (0, _useDynamicPageContent.default)(),
    setDynamicContentPage = _useDynamicPageConten.setDynamicContentPage;
  var buttonText = _services.locale.localeString(selected ? 'AccessoryModal.RemovePlan' : 'AccessoryModal.SelectPlan');
  var handleConnectivityPlanSelect = function handleConnectivityPlanSelect() {
    setConnectivityPlanIsSelected(!selected);
    setDynamicContentPage(_constants.DYNAMIC_PAGES.UPSELL_DETAILS);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    id: "upsell-connectivity-plan"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 5,
      bottom: 5
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    appearance: "secondary",
    size: 2,
    justify: 'center',
    weight: 3,
    text: _services.locale.localeString("AccessoryModal.PlanDetails"),
    noMargin: true
  })), specsGroups.map(function (group) {
    return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
      key: group.name,
      spacingLevel: {
        bottom: 3
      }
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Accordion, {
      id: "accordion-id",
      dataSelectorPrefix: "accordion",
      dataAttributes: {
        'data-test-id': 'accordion'
      }
    }, /*#__PURE__*/_react.default.createElement(_CharacteristicsGroup.default, {
      group: group,
      characteristics: characteristics.filter(function (characteristic) {
        return characteristic.charGroup.includes(group.name);
      })
    })));
  }), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 5
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    justify: "center"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, {
    col: 6
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Button, {
    id: "connectivity-plan-select",
    width: "full",
    text: buttonText,
    appearance: selected ? 'primary' : 'secondary',
    onClick: handleConnectivityPlanSelect
  })))));
};
var _default = UpsellConnectivityPlanBody;
exports.default = _default;